import { categories } from '@/mocks/homeData';

export default function CategoriesSection() {
  return (
    <section className="relative w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 tracking-tight mb-3">
            热门竞猜项目
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            覆盖全球主流体育赛事与电竞项目，总有你热爱的比赛
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={`/category/${cat.id}`}
              className="group relative bg-background-50 rounded-xl p-5 md:p-6 border border-background-200 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className={`w-12 h-12 md:w-14 md:h-14 rounded-xl ${cat.color} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${cat.icon} text-xl md:text-2xl text-background-50 dark:text-foreground-950`}></i>
              </div>
              <h3 className="text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed mb-3">
                {cat.description}
              </p>
              <div className="flex items-center justify-between">
                <span className="text-xs font-medium text-foreground-400">
                  {cat.matchCount.toLocaleString()}+ 场赛事
                </span>
                <span className="text-xs font-semibold text-primary-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  立即进入 <i className="ri-arrow-right-s-line"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}